export const gitCommit = 'a55d2885'
